"use client";

import { useTranslation } from "@/hooks/useTranslation";

export default function PrivacyPolicyContent() {
	const { t } = useTranslation();

	const sections = [
		"section1",
		"section2",
		"section3",
		"section4",
		"section5",
		"section6",
		"section7",
		"section8",
	];

	return (
		<div className="space-y-6">
			{sections.map((section) => (
				<div key={section} className="space-y-2">
					<h3 className="text-lg font-semibold text-gray-900">
						{t(`privacy.content.${section}.title`)}
					</h3>
					<p className="text-gray-700 leading-relaxed">
						{t(`privacy.content.${section}.text`)}
					</p>
				</div>
			))}
		</div>
	);
}